import { createSlice } from "@reduxjs/toolkit";
import { getStudentMeetings } from "./student-meeting-thunk";

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: null,
};

export const teacherCourseDataSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStudentMeetings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudentMeetings.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(getStudentMeetings.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
    });
  },
});

export default teacherCourseDataSlice.reducer;
